import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import RelationshipTypesConverter from '../converter/RelationshipTypesConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default { getRelationshipTypes: getRelationshipTypes };

function getRelationshipTypes (reservationId) {
  reservationId = reservationId || 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.getRelationshipTypes&timestamp=${currentMillis}&reservationid=${reservationId}`;
  return fetch(url, Request.getBase())
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }

          return {
            status: status,
            data: RelationshipTypesConverter.relationshipTypesWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}



// WEBPACK FOOTER //
// ./src/remoting/RelationshipTypesRemoting.js